import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import {
  CustomSelect,
  InputTextarea,
  SubmitLoaderButton,
} from "components/atoms";
import { StatusManageUserAction } from "store/middlewares/user";

import { GetAllReasonsForSelectAction } from "store/middlewares/dataManagement/activityReason";

const ModalBlockDeleteReason = ({ type, id, filter }) => {
  const dispatch = useDispatch();

  const { allReasons } = useSelector((state) => state.reason);
  const [formError, setFormError] = useState(false);

  useEffect(() => {
    const mappedType = type === "deleted" ? "delete" : type;
    dispatch(GetAllReasonsForSelectAction({ type: mappedType }));
  }, [type]);

  const reasonOptions = [
    ...(Array.isArray(allReasons)
      ? allReasons.map((item) => ({
          label: item.en_name,
          value: item.en_name,
        }))
      : []),
    { label: "Other", value: "other" },
  ];

  const formik = useFormik({
    initialValues: {
      selectedReason: "",
      otherReason: "",
    },
    validationSchema: Yup.object({
      selectedReason: Yup.string().required("Please select a reason"),
      otherReason: Yup.string().when("selectedReason", {
        is: "other",
        then: (schema) => schema.required("Reason is required"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    onSubmit: (values) => {
      const finalReason =
        values.selectedReason === "other"
          ? values.otherReason
          : values.selectedReason;

      dispatch(
        StatusManageUserAction({
          reason: finalReason,
          status: type,
          id,
          filter,
          onSuccess: () => formik.setSubmitting(false),
          onError: () => setFormError(true),
        }),
      );
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <div className="mb-3">
        <label className="text-sm font-medium text-foreground mb-1 block">
          Select Reason
        </label>
        <CustomSelect
          className="w-full"
          val={formik.values.selectedReason}
          options={reasonOptions}
          placeholder="Select a reason"
          onChange={(value) => {
            formik.setFieldValue("selectedReason", value);
            if (value !== "other") {
              formik.setFieldValue("otherReason", "");
            }
          }}
          error={formik.errors.selectedReason && formik.touched.selectedReason}
          errorMsg={formik.errors.selectedReason}
        />
      </div>

      {formik.values.selectedReason === "other" && (
        <InputTextarea
          textareaClassName="rounded-lg w-full px-2 py-2 mt-3 no-scrollbar"
          label="Other Reason"
          name="otherReason"
          maxLength={250}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values.otherReason}
          error={formik.errors.otherReason && formik.touched.otherReason}
          errorMsg={formik.errors.otherReason}
          placeholder="Enter reason"
        />
      )}

      <div className="flex justify-end mt-4">
        <SubmitLoaderButton
          btnText={"Submit"}
          isDisable={formik.isSubmitting && !formError}
        />
      </div>
    </form>
  );
};

export default ModalBlockDeleteReason;
